module.exports = __webpack_public_path__ + "img/chevron_up.2e0dd82b.svg";